import { FilterAlt } from '@mui/icons-material';
import { useGridApiContext } from '@mui/x-data-grid';

export const CustomFilterIcon = () => {
  const apiRef = useGridApiContext();
  apiRef;
  return <FilterAlt fontSize="small" className="icon" />;
};
